var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#001c33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 20,
    strokeWidth: 2,
    d: "M1.13 5.246v0l4.604 4.046v0l5.878-8.122v0"
  })));
}
export default SvgCheckmark;